var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultImageLarge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 130,
    height: 120,
    viewBox: "0 0 96 79",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 95,
    height: 78,
    rx: 8.5,
    fill: "white",
    stroke: "#DADADA"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.5, 19)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.1377 5.8623H18.471V19.1956H5.1377V5.8623ZM5.1377 22.529H18.471V35.8623H5.1377V22.529ZM21.8044 5.8623H35.1377V19.1956H21.8044V5.8623ZM21.8044 22.529H35.1377V35.8623H21.8044V22.529ZM25.1377 9.19564V15.8623H31.8044V9.19564H25.1377ZM25.1377 25.8623V32.529H31.8044V25.8623H25.1377ZM8.47103 9.19564V15.8623H15.1377V9.19564H8.47103ZM8.47103 25.8623V32.529H15.1377V25.8623H8.47103Z",
    fill: "#A49F9F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultImageLarge);
export default __webpack_public_path__ + "static/media/defaultImageLarge.f1d8fd2858faab6c0c8c32936ca6f963.svg";
export { ForwardRef as ReactComponent };